export default __webpack_public_path__ + "static/media/delivery-1.84825c96.png";